export default {
    getTopTenCriminals(state) {
      return state.topTenCriminals;
    },
    getTopTenCrimes(state) {
      return state.topTenCrimes;
    },
    getTopTenSentences(state) {
      return state.topTenSentences;
    },
    getCriminalsSoap(state) {
      return state.criminalsSoap;
    },
    getCrimesSoap(state) {
      return state.crimesSoap;
    },
    getSentencesSoap(state){
      return state.sentencesSoap;
    },
    getCrimeDetails(state){
        return state.isShowCrimeDetails;
    },
    getSentenceDetails(state){
      return state.isShowSentenceDetails;
    }
}